import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "modelType",
        "mentionFieldset",
        "appointment",
        "foreign",
        "foreign",
        "doctor",
        "rpps",
        "name",
        "issueDate",
        "form"
    ]

    static values = {
        pdfUrl: String,
        pdfData: String
    }

    connect() {
        if (this.hasModelTypeTarget) {
            // Delay to let Select2 instances to correctly initialize
            setTimeout(() => {
                this.changeMentionsSelect();
            }, 10)
        }
        if (this.hasAppointmentTarget) {
            this.changeAppointment();
        }
    }

    changeMentionsSelect() {
        this.modelTypeTargets.forEach(modelType => {
            if (modelType.checked && modelType.value === 'competition') {
                this.setFieldset(modelType.value);
            } else if (modelType.checked && modelType.value === 'hobby') {
                this.setFieldset(modelType.value);
            }
        })
    }

    setFieldset(active) {
        this.mentionFieldsetTargets.forEach( fieldset => {
            if (fieldset.id === active) {
                fieldset.disabled = false;
                fieldset.style.display = 'block';
            } else {
                fieldset.disabled = true;
                fieldset.style.display = 'none';
            }
        });
    }
    changeAppointment() {
        this.appointmentTargets.forEach(appointment => {
            if (appointment.checked && appointment.value === 'with_appointment') {
                this.enableAppointment();
            } else if (appointment.checked && appointment.value === 'without_appointment') {
                this.disableAppointment();
            }
        })
    }

    enableAppointment() {
        this.foreignTargets.forEach(foreign => {
            foreign.disabled = false;
        });
        this.doctorTarget.disabled = false;
        this.rppsTarget.disabled = false;
        this.nameTarget.disabled = false;
        this.issueDateTarget.disabled = false;
        $(this.formTarget).enableClientSideValidations();
    }

    disableAppointment() {
        this.foreignTargets.forEach(foreign => {
            foreign.disabled = true;
        });
        this.doctorTarget.disabled = true;
        this.rppsTarget.disabled = true;
        this.nameTarget.disabled = true;
        this.issueDateTarget.disabled = true;
        $(this.formTarget).resetClientSideValidations();
        $(this.formTarget).enableClientSideValidations();
    }
}
